// Fonction pour gérer le scroll
const headerHead = document.querySelector('.header .head');

function handleScroll() {
    if (window.scrollY > 0) {
        // Si on a scrollé vers le bas (scrollY > 0), ajouter la classe "active"
        headerHead.classList.add('active');
    } else {
        // Si on est tout en haut de la page (scrollY === 0), retirer la classe "active"
        headerHead.classList.remove('active');
    }
}
window.addEventListener('scroll', handleScroll);


// animations
document.addEventListener('DOMContentLoaded', function() {
    // Sélectionnez tous les éléments avec des classes d'animation différentes
    const elementsFade = document.querySelectorAll('.hidden-fade');
    const elementsBottom = document.querySelectorAll('.hidden-bottom');
    const elementsLeft = document.querySelectorAll('.hidden-left');
    const elementsRight = document.querySelectorAll('.hidden-right');

    // Fonction pour ajouter la classe "visible" si l'élément est visible dans la fenêtre
    const handleScroll = () => {
        const handleVisibility = (elements, visibleClass) => {
            elements.forEach(element => {
                const rect = element.getBoundingClientRect();

                // Si l'élément est visible dans la fenêtre
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    element.classList.add(visibleClass);
                }
            });
        };

        // Applique les classes visibles pour chaque direction
        handleVisibility(elementsFade, 'visible-fade');
        handleVisibility(elementsBottom, 'visible-bottom');
        handleVisibility(elementsLeft, 'visible-left');
        handleVisibility(elementsRight, 'visible-right');
    };

    // Lancer l'effet au chargement de la page et lors du défilement
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Appel initial pour les éléments déjà visibles
});